export const getAppkit = () => {
  throw new Error("@reown/appkit is not supported on native");
};
